import Icon from 'veui/components/Icon'
import { IconMinusCircle } from 'dls-icons-vue'

Icon.register('minus-circle', IconMinusCircle)
